import React, { useState, useEffect } from "react";
import FilterDrawer from "../../../../layout/Workspace/drawers/FilterDrawer";
import { useSelector, useDispatch } from "react-redux";
// import { getFilterPanelData } from "../../../../../redux/constants";
// import { setFilterPanelData } from "../../../../../redux/actions/Filter";
import isEqual from "react-fast-compare";
import { screensWithPersistedFilters } from "../../../../../redux/constants/enums";
const Filters = ({
  setisFilterApplied,
  isFilterApplied,
  widgetsClearFilter,
  setwidgetsClearFilter,
  noteEdited,
  setNoteEdited,
}) => {
  // const dispatch = useDispatch();
  const [filterSearch, setfilterSearch] = useState("");
  const [searchTerm, setSearchTerm] = useState(null);
  // const config = useSelector((state) => state.apiCall.config);
  const editPanelInfo = useSelector((state) => state.dashboard?.editPanelInfo);
  const isWidgetEdit = useSelector((state) => state.Filter.isWidgetEdit);
  const screen = useSelector((state) => state?.Screens?.screen);
  const authParams = useSelector((state) => state.Authentication.authParams);
  const personalizationSettingsObj = useSelector(
    (state) => state?.PersonalizationSetting
  );
  let isPersonalisedBannerAdded =
    authParams?.screen_id &&
    (personalizationSettingsObj?.CommandCenterLayout === "B1F0" ||
      personalizationSettingsObj?.CommandCenterLayout === "B1F1");
  // useEffect(() => {
  //   if (config) {
  //     //to set filter panel data
  //     let myArray = getFilterPanelData(config);
  //     dispatch(setFilterPanelData(myArray));
  //   }
  // }, [config]);
  return (
    <>
      <div
        className={`${
          editPanelInfo?.type === "command_center_section" ||
          editPanelInfo?.type === "command_center_widget"
            ? "command_center_widget_filter_drawer_if custom_scroll1"
            : "command_center_widget_filter_drawer_else custom_scroll"
        } ${
          authParams?.screen_id &&
          screen?.widgets?.length > 1 &&
          (screensWithPersistedFilters.includes(authParams?.screen_id) ||
            authParams?.screen_id === "000-000-550")
            ? "custom_scroll_inscreen"
            : "custom_scroll"
        } ${
          isPersonalisedBannerAdded && authParams?.screen_id === "000-000-557"
            ? "personalised_filter_drawer_stream"
            : isPersonalisedBannerAdded && authParams?.screen_id
            ? "personalised_filter_drawer"
            : ""
        }`}
        style={{
          // height:
          //   editPanelInfo?.type === "command_center_section" ||
          //   editPanelInfo?.type === "command_center_widget"
          //     ? "calc(100vh - 20rem)"
          //     : "calc(100vh - 15rem)",
          overflow: "auto",
          marginRight: "0.5rem",
          paddingRight: "0.5rem",
        }}
      >
        {isWidgetEdit && (
          <FilterDrawer
            setfilterSearch={setfilterSearch}
            filterSearch={filterSearch}
            isFilterApplied={isFilterApplied}
            setisFilterApplied={setisFilterApplied}
            widgetsClearFilter={widgetsClearFilter}
            setwidgetsClearFilter={setwidgetsClearFilter}
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            type={
              editPanelInfo?.type === "dashboard_section"
                ? "dashboard_section"
                : editPanelInfo?.type === "dashboard_widget"
                ? "dashboard_widget"
                : editPanelInfo?.type === "command_center_section"
                ? "command_center_section"
                : editPanelInfo?.type === "command_center_widget"
                ? "command_center_widget"
                : editPanelInfo?.type === "template_section"
                ? "template_section"
                : editPanelInfo?.type === "template_widget" && "template_widget"
            }
            noteEdited={noteEdited}
            setNoteEdited={setNoteEdited}
          />
        )}
      </div>
    </>
  );
};

export default React.memo(Filters, isEqual);
